import { FormGroup, Input, Label } from "reactstrap";
import { handleFormChange } from "../../../components/modals/EditableTable";
import { useEffect, useState } from "react";
import axios from "axios";
import Cookies from "js-cookie";
import { useTranslation } from "react-i18next";
import InfoTip from "../../../components/InfoTip";
import Loading from "../../../components/utils/Loading";

/**
 * Carte Gestion – Flux *, Remplissage critique * (%), Suivi du compactage (checkbox).
 */
const ZoneSettingsGestion = ({ formData, setFormData, setErrorForm }) => {
  const { t } = useTranslation();
  const API = process.env.REACT_APP_API_BACKEND;
  const token = Cookies.get("userToken");
  const [wasteNames, setWasteNames] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(`${API}wastecategory/getWasteName`, {
          headers: { authorization: `Bearer ${token}` },
        });
        if (res?.status === 200)
          setWasteNames(res.data?.wasteCategoryName || []);
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
  }, [API, token]);

  const inputClass =
    "w-full zone-settings__input bg-white border border-gray-300 rounded-lg";

  if (isLoading) return <Loading height="120px" />;

  return (
    <div className="flex flex-col w-full">
      {/* Flux * – contentCategory + secondfield wasteName, valeur normalisée pour affichage */}
      <FormGroup className="mb-4">
        <Label className="zone-settings__label">
          {t("containerSettings.flow")}{" "}
          <span className="zone-settings__required">*</span>
        </Label>
        <Input
          className={inputClass}
          type="select"
          value={
            formData.contentCategory == null || formData.contentCategory === ""
              ? ""
              : String(formData.contentCategory)
          }
          onChange={(e) => handleFormChange(e, formData, setFormData)}
          name="contentCategory"
          secondfield="wasteName"
        >
          <option value="">{t("containerSettings.unspecified")}</option>
          {wasteNames.map((flux) => (
            <option
              key={flux._id}
              value={String(flux._id)}
              secondvalue={flux.label}
            >
              {flux.label}
            </option>
          ))}
        </Input>
      </FormGroup>

      {/* Remplissage critique * – % à droite dans le champ (maquette) */}
      <FormGroup className="mb-4">
        <Label className="zone-settings__label">
          {t("containerSettings.criticalFilling")}{" "}
          <span className="zone-settings__required">*</span>
        </Label>
        <div className="relative w-full">
          <Input
            className={`${inputClass} pr-10`}
            type="number"
            placeholder="80"
            value={formData.limitFillingLevel ?? ""}
            onChange={(e) => handleFormChange(e, formData, setFormData)}
            name="limitFillingLevel"
            max={100}
            min={0}
          />
          <span className="zone-settings__unit-suffix">%</span>
        </div>
      </FormGroup>

      {/* Suivi du compactage – checkbox + label + info (maquette), aligné comme les autres champs */}
      <FormGroup className="mb-0 pt-2">
        <div className="zone-settings__checkbox-row flex items-center gap-2">
          <div className="zone-settings__checkbox-wrap">
            <Input
              type="checkbox"
              id="zone-packmat"
              checked={!!formData.packmatActive}
              onChange={(e) => handleFormChange(e, formData, setFormData)}
              name="packmatActive"
              className="zone-settings__checkbox"
            />
          </div>
          <Label
            htmlFor="zone-packmat"
            className="zone-settings__checkbox-label mb-0"
          >
            {t("containerSettings.followUpCompaction")}
          </Label>
          <InfoTip nudgeY={1}>
            {t("Activate the measurement and indicators of compaction")}.
          </InfoTip>
        </div>
      </FormGroup>
    </div>
  );
};

export default ZoneSettingsGestion;
